import BookingState from './Enums/BookingState';

export enum VisibilityScope {
  CUSTOMER_DATA = 'CUSTOMER_DATA',
  EVENT_NOTES = 'EVENT_NOTES',
  EVENT_KIND = 'EVENT_KIND',
  EVENT_STATE = 'EVENT_STATE',
  EVENT_NAME = 'EVENT_NAME',
  EVENT_DESCRIPTION = 'EVENT_DESCRIPTION',
  LOCATION = 'LOCATION',
  ONLY_LOCATION_CITY = 'ONLY_LOCATION_CITY',
}

export interface GoogleAccountDTO {
  id: number;
  email: string;
  hasCalendarScopes: boolean;
  hasContactScopes: boolean;
  hasTasksScopes: boolean;
  hasDriveScopes: boolean;
  hasSendMailScope: boolean;
  syncTasksAutomatically: boolean;
  syncContactsAutomatically: boolean;
  photoUrl: string;
}

export interface GoogleCalendarDto {
  id: number;
  profileId: number;
  googleAccountId: number;
  calendarId: string;
  calendarName: string;
  calendarDescription: string;
  foregroundColor: string;
  backgroundColor: string;
  read: boolean;
  checkForClashes: boolean;
  write: boolean;
  insertAsFullTimeEvents: boolean;
  recommendation: boolean;
  insertOnlySharedRecommendations: boolean;
  owner: string;
  ownerIconUrl: string;
  useCustomStateLabels: boolean;
  useEventDateDescription: boolean;
  customFields: string[];
  visibilityScopes: VisibilityScope[];
  statesOfInterest: BookingState[];
  customStatesOfInterest: string[];
  kindsOfInterest: string[];
}
